import React, { Component } from 'react'

export default class Experience extends Component {
    render() {
        return (
            <section className="experience" id="experience">
                <div className="container">
                    <div className="section-heading"> 
                        <h1> Experience </h1>
                        <h6>My studies and Jobs.</h6>
                    </div>
                    <div className="timeline">
                        <ul>
                            <li className="date" data-date="2018 - Present">
                                <h1> SAIPEM : NDT Engineer & Dashboard Developer - PARIS</h1>
                                <p> Lead Engineer - Non Destructive Testing on pipeline laying projects all around the world.
                                    My job is to produce NDT procedures and documentation for Radiography (gamma and X-ray), 
                                    Dye Penetrant Inspection, Magnetic Particle Inspection, Visual Inspection, Manual Ultrasonc Inspection, 
                                    Automatic Ultrasonic Inspection.
                                    Procedures and documentation shall fulfilled all requirements from very specific standards such as DNVGL-ST-F101, API1104, 
                                    ASME standards and also company specifications.
                                </p>
                            </li>
                            <li className="date" data-date="2018 - 2019">
                                <h1> SAIPEM : R&D SUBJECT | VBA / EXCEL / ACCESS - PARIS</h1>
                                <p> Initiating the idea of a common database for gathering all the data recorded onboard Pipelayer Vessels (offshore) and yards 
                                    (onshore). The purpose is to keep track of all projects to analyse/ predict recurrent issues.
                                    I choosed then to move the whole project on Django / React application (please see my portfolio above).
                                </p>
                            </li>
                            <li className="date" data-date="2018 - Present">
                                <h1> Continuous development - HOME</h1>
                                <p> Developming personnal projects for entertainment and self-learning. Keeping updated with new features and
                                    training on Django, React, HTML, CSS, API Frameworks, PostgreSQL and more !
                                </p>
                            </li>
                            <li className="date" data-date="2017 - 2018">
                                <h1> Engineer School - SupAero - TOULOUSE </h1>
                                <p> 
                                    Topics: Vibrations, Composites (Polymers, Processes, machining et structural damaging), Plasticity.
                                    Fracture  and Mechanical measurements.<br/>
                                    
                                </p>
                            </li>
                            <li className="date" data-date="2015 - 2018">
                                <h1> Engineer School - IMT Mines Albi </h1>
                                <p> 
                                    Major :  Innovation Management in Aerospace.<br/>
                                    Option : Aeronautical Techniques.<br/>
                                    Specialization : Polymers and composites at Clément Ader research center. <br/>
                                    
                                </p>
                            </li>
                            <li className="date" data-date="2013 - 2015">
                                <h1> Classes Préparatoires aux Grandes Ecoles - Descartes - TOURS. </h1>
                                <p> Specification Math - Physics - Science of engineering.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        )
    }
}
